import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const toastsStateSelector = (state: RootState) => state.toasts;

export const toastsSelector = createSelector(
    toastsStateSelector,
    (state) => state.toasts
);
